import React, { useState } from 'react';
import { Box, Tabs, Tab, Card } from '@mui/material';
import { Groups, PhoneIphone, Security, AccountBalance, MonetizationOn, ToggleOn, ContactSupport, Gavel, Help, LocalHospital, DirectionsCar, Schedule } from '@mui/icons-material';
import SettingsRolesPage from './SettingsRolesPage';
import MobileAppSettingsPage from './MobileAppSettingsPage';
import RentalSettingsPage from './RentalSettingsPage';
import PaymentSettingsPage from './PaymentSettingsPage';
import PayoutSettingsPage from './PayoutSettingsPage';
import FeatureTogglesPage from './FeatureTogglesPage';
import SupportContactsPage from './SupportContactsPage';
import LegalDocumentsPage from './LegalDocumentsPage';
import FAQManagementPage from './FAQManagementPage';
import EmergencyContactsPage from './EmergencyContactsPage';
import { VehicleTypesSettingsPage } from './VehicleTypesSettingsPage';
import BookingTimeoutSettingsPage from './BookingTimeoutSettingsPage';

export const SettingsPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Box sx={{ p: 3 }}>
      {/* Tabs Navigation */}
      <Card sx={{ mb: 3 }}>
        <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
          <Tab icon={<Groups />} label="Roles & Permissions" />
          <Tab icon={<PhoneIphone />} label="Mobile App Controls" />
          <Tab icon={<ToggleOn />} label="Feature Toggles" />
          <Tab icon={<DirectionsCar />} label="Vehicle Types" />
          <Tab icon={<Security />} label="Rental Settings" />
          <Tab icon={<Schedule />} label="Booking Timeouts" />
          <Tab icon={<AccountBalance />} label="Payment Settings" />
          <Tab icon={<MonetizationOn />} label="Payout Settings" />
          <Tab icon={<ContactSupport />} label="Support Contacts" />
          <Tab icon={<Gavel />} label="Legal Documents" />
          <Tab icon={<Help />} label="FAQ Management" />
          <Tab icon={<LocalHospital />} label="Emergency Contacts" />
        </Tabs>
      </Card>

      {/* Tab Content */}
      {selectedTab === 0 && <SettingsRolesPage />}
      {selectedTab === 1 && <MobileAppSettingsPage />}
      {selectedTab === 2 && <FeatureTogglesPage />}
      {selectedTab === 3 && <VehicleTypesSettingsPage />}
      {selectedTab === 4 && <RentalSettingsPage />}
      {selectedTab === 5 && <BookingTimeoutSettingsPage />}
      {selectedTab === 6 && <PaymentSettingsPage />}
      {selectedTab === 7 && <PayoutSettingsPage />}
      {selectedTab === 8 && <SupportContactsPage />}
      {selectedTab === 9 && <LegalDocumentsPage />}
      {selectedTab === 10 && <FAQManagementPage />}
      {selectedTab === 11 && <EmergencyContactsPage />}
    </Box>
  );
};